import { createAction } from "redux-actions";

export const actionTypes = {
    GET_SMS_TRANSACTIONS: 'transaction/GET_SMS_TRANSACTIONS',
    EXPORT_TRANSACTIONS: 'transaction/EXPORT_TRANSACTIONS',
}

export const actions = {
    getSMSTransactions: createAction(actionTypes.GET_SMS_TRANSACTIONS),
    exportTransactions: createAction(actionTypes.EXPORT_TRANSACTIONS),
}